(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-iglike-lite"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

if (document.querySelector(".iglike-item-slider")) {
  const iglikeItemSlider = new Swiper(".iglike-item-slider", {
    slidesPerView: 5,
    spaceBetween: 20,
    speed: 600,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: ".iglike-swiper-button-next",
      prevEl: ".iglike-swiper-button-prev",
    },
    pagination: {
      el: ".iglike-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 5,
        spaceBetween: 20,
      }
    },
    on: {
      init: function () {
        this.el.classList.remove("iglike-item-slider__pre-init");
      }
    }
  });
}

const iglikeModalSwiper = new Swiper(".iglike-modal-swiper", {
  direction: "vertical",
  spaceBetween: 10,
  navigation: {
    nextEl: ".iglike-modal-next",
    prevEl: ".iglike-modal-prev",
  },
  mousewheel: true,
  on: {
    slideChangeTransitionEnd(swiper) {
      playVideoInSlide(swiper);
    }
  }
});

function playVideoInSlide(swiper) {
  swiper.slides.forEach((slide, index) => {
    const video = slide.querySelector('video');
    if (video) {
      if (index === swiper.activeIndex) {
        video.currentTime = 0;
        video.play().catch(err => {
          console.warn('再生できません:', err);
        });
      } else {
        video.pause();
        video.currentTime = 0;
      }
    }
  });
}

const iglikeModal = document.getElementById("IglikeVideoModal");
const iglikeCloseModalBtns = document.querySelectorAll(".iglike-modal-close");

document.querySelectorAll(".iglike-mov-thumbnail").forEach((thumb, index) => {
  thumb.addEventListener("click", () => {
    iglikeModal.classList.add("show");
    iglikeModalSwiper.slideTo(index, 0);
    setTimeout(() => {
      playVideoInSlide(iglikeModalSwiper);
    }, 30);

  });
});

iglikeCloseModalBtns.forEach(btn => {
  btn.addEventListener("click", () => {
    iglikeModal.classList.remove("show");
    stopAllVideos();
  });
});

iglikeModal.addEventListener("click", (e) => {
  if (e.target === iglikeModal) {
    iglikeModal.classList.remove("show");
    stopAllVideos();
  }
});

function stopAllVideos() {
  document.querySelectorAll(".iglike-modal video").forEach((video) => {
    video.pause();
    video.currentTime = 0;
  });
}

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-iglike"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

if (document.querySelector(".iglike-item-slider")) {
  const iglikeItemSlider = new Swiper(".iglike-item-slider", {
    slidesPerView: 5,
    spaceBetween: 20,
    speed: 600,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: ".iglike-swiper-button-next",
      prevEl: ".iglike-swiper-button-prev",
    },
    pagination: {
      el: ".iglike-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 5,
        spaceBetween: 20,
      }
    },
    on: {
      init: function () {
        this.el.classList.remove("iglike-item-slider__pre-init");
      }
    }
  });
}

const iglikeModalSwiper = new Swiper(".iglike-modal-swiper", {
  direction: "vertical",
  spaceBetween: 10,
  navigation: {
    nextEl: ".iglike-modal-next",
    prevEl: ".iglike-modal-prev",
  },
  mousewheel: true,
  on: {
    slideChangeTransitionEnd(swiper) {
      playVideoInSlide(swiper);
    }
  }
});

function playVideoInSlide(swiper) {
  swiper.slides.forEach((slide, index) => {
    const video = slide.querySelector('video');
    if (video) {
      if (index === swiper.activeIndex) {
        video.currentTime = 0;
        video.play().catch(err => {
          console.warn('再生できません:', err);
        });
      } else {
        video.pause();
        video.currentTime = 0;
      }
    }
  });
}

const iglikeModal = document.getElementById("IglikeVideoModal");
const iglikeCloseModalBtns = document.querySelectorAll(".iglike-modal-close");

document.querySelectorAll(".iglike-mov-thumbnail").forEach((thumb, index) => {
  thumb.addEventListener("click", () => {
    iglikeModal.classList.add("show");
    iglikeModalSwiper.slideTo(index, 0);
    setTimeout(() => {
      playVideoInSlide(iglikeModalSwiper);
    }, 30);

  });
});

iglikeCloseModalBtns.forEach(btn => {
  btn.addEventListener("click", () => {
    iglikeModal.classList.remove("show");
    stopAllVideos();
  });
});

iglikeModal.addEventListener("click", (e) => {
  if (e.target === iglikeModal) {
    iglikeModal.classList.remove("show");
    stopAllVideos();
  }
});

function stopAllVideos() {
  document.querySelectorAll(".iglike-modal video").forEach((video) => {
    video.pause();
    video.currentTime = 0;
  });
}

document.querySelectorAll(".iglike-wrapper a").forEach(function(elm) {
  try {
    let url = new URL(elm.href);
    url.searchParams.set("via", "iglike");
    elm.href = url.toString();
  } catch (e) {
    console.warn("invalid link:", elm.href);
  }
});

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["original-tags-filter"] && !Shopify.designMode) return;
  try {
    
  if(document.getElementById('filter-by-tags')){
    let uri = decodeURI(location.pathname);
    let temp = uri.split("/");
    uri = "/" + temp[1] + "/" + temp[2] + "/";
    let selected_tags = [];
    if(typeof temp[3] !== 'undefined'){
      selected_tags = temp[3].split("+");
    }
    filter_by_tags_setlink(uri,selected_tags);
  }
  function filter_by_tags_setlink(uri,selected_tags){
    let display_tags = [];
    const items = document.querySelectorAll('.filter-by-tags_item-value');
    items.forEach(function(e) {
      let tag = e.dataset.tag;
      if(selected_tags.length > 0){
        let check_tag_index = selected_tags.indexOf(tag);
        if(check_tag_index !== -1){
          let removed_tags = selected_tags.concat();
          removed_tags.splice(check_tag_index, 1);
          e.classList.add("__selected");
          display_tags.push(tag);
          e.setAttribute('href',uri+removed_tags.join('+'));
        }else{
          e.setAttribute('href',uri+selected_tags.join('+')+"+"+tag);
        }
      }else{
        e.setAttribute('href',uri+tag);
      }
    });
    const rankingState = document.querySelector('.product-ranking-container__close');
    if(display_tags.length > 0){
      const display_tags_label = display_tags.join(',');
      document.getElementById('filter-selector_selected-tags').textContent = display_tags_label;
      if (rankingState) {
        rankingState.addEventListener('click', function() {
          rankingState.classList.remove('product-ranking-container__close');
        });
      }
    }else{
      document.getElementById('filter-selector_selected-tags').textContent = "サイズや種類で絞り込む";
      if (rankingState) {
        rankingState.classList.remove('product-ranking-container__close');
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["original-tags-filter2026"] && !Shopify.designMode) return;
  try {
    
if(document.getElementById('filter-by-tags')){
let uri = decodeURI(location.pathname);
let temp = uri.split("/");
uri = "/" + temp[1] + "/" + temp[2] + "/";
let selected_tags = [];
if(typeof temp[3] !== 'undefined'){
selected_tags = temp[3].split("+");
}
filter_by_tags_setlink(uri,selected_tags);
}
function filter_by_tags_setlink(uri,selected_tags){
let display_tags = [];
const items = document.querySelectorAll('.filter-by-tags_item-value');
items.forEach(function(e) {
let tag = e.dataset.tag;
if(selected_tags.length > 0){
let check_tag_index = selected_tags.indexOf(tag);
if(check_tag_index !== -1){
let removed_tags = selected_tags.concat();
removed_tags.splice(check_tag_index, 1);
e.classList.add("__selected");
display_tags.push(tag);
e.setAttribute('href',uri+removed_tags.join('+'));
}else{
e.setAttribute('href',uri+selected_tags.join('+')+"+"+tag);
}
}else{
e.setAttribute('href',uri+tag);
}
});
const rankingState = document.querySelector('.product-ranking-container__close');
if(display_tags.length > 0){
const display_tags_label = display_tags.join(',');
document.getElementById('filter-selector_selected-tags').textContent = display_tags_label;
if (rankingState) {
rankingState.addEventListener('click', function() {
rankingState.classList.remove('product-ranking-container__close');
});
}
}else{
document.getElementById('filter-selector_selected-tags').textContent = filter_by_tags_default_label;
if (rankingState) {
rankingState.classList.remove('product-ranking-container__close');
}
}
}

  } catch(e) { console.error(e); }
})();
})();
